export function getFocusHandlerProps(props, ref) {
    var propsToUse = {
        onFocus: props.onFocus,
        onFocusCapture: props.onFocusCapture,
        onBlur: props.onBlur,
        onBlurCapture: props.onBlurCapture,
        onCopy: props.onCopy,
        onCopyCapture: props.onCopyCapture,
        onCut: props.onCut,
        onCutCapture: props.onCutCapture,
        onPaste: props.onPaste,
        onPasteCapture: props.onPasteCapture,
        tabIndex: props.tabIndex,
        autoFocus: props.autoFocus,
    };
    if (props.noFocuseable === true) {
        propsToUse.tabIndex = -1;
        propsToUse.autoFocus = false;
    }
    if (props.refBlur) {
        var propOnBlur_1 = props.onBlur;
        propsToUse.onBlur = function (e) { propOnBlur_1 && propOnBlur_1(e); props.refBlur(ref.current, e); };
    }
    if (props.refFocus) {
        var propOnFocus_1 = props.onFocus;
        propsToUse.onFocus = function (e) { propOnFocus_1 && propOnFocus_1(e); props.refFocus(ref.current, e); };
    }
    var stylesToUse = {};
    if (typeof props.cursor === 'string') {
        stylesToUse.cursor = props.cursor;
    }
    return {
        classes: {},
        props: propsToUse,
        styles: stylesToUse,
        variables: {
            focuseable: typeof props.focuseable === 'undefined' || props.focuseable === true || propsToUse.tabIndex > 0
        }
    };
}
